import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import AdminFooter from './AdminFooter';
import 'react-quill/dist/quill.snow.css';
import "cropperjs/dist/cropper.min.css";
import { isAuthenticated } from '../middleware/admin_auth';

function AdminEnquiryView() {

    useEffect(() => {
        // Check if the user is authenticated
        if (!isAuthenticated()) {
          // Redirect to the login page
          window.location.href = '/guru';
        }
    }, []);
    
    const { id } = useParams();
    const [orderDetails, setOrderDetails] = useState({ 
        id: null, 
        fullName: '', 
        email: '', 
        mobileNumber: '', 
        noOfPersons: '', 
        hotelType: '',
        startDate: '', 
        endDate: '', 
        message: '', 
        website: '', 
        page_title: '', 
        submit_date: ''
    });

    const apiUrl = `${process.env.REACT_APP_API_ENDPOINT}enquiry_listings?id=${id}`;
    //console.log("api_url", apiUrl);

    useEffect(() => {
        fetch(apiUrl)
          .then(response => response.json())
          .then(data => {
            if (Array.isArray(data) && data.length > 0) {
              setOrderDetails(data[0]);
            }
          })
          .catch(error => console.error(error));
    }, []);
    
    return (
        <div class="dashboard__main">

            <div class="dashboard__content bg-light-2">
                <div class="row y-gap-20 justify-between items-end pb-30 lg:pb-40 md:pb-32">
                    <div class="col-auto">

                        <h1 class="text-30 lh-14 fw-600">Enquiry Details</h1>

                    </div>
                </div>


                <div class="py-30 px-30 rounded-4 bg-white shadow-3" style={{marginBottom:200}}>
                    <div class="col-12"><p>Enquiry ID: <b>{orderDetails?.id}</b></p></div>
                    <div class="col-12"><p>Page Name: <b>{orderDetails?.page_title}</b></p></div>
                    <div class="col-12"><p>Customer Name: <b>{orderDetails?.fullName}</b></p></div>
                    <div class="col-12"><p>Email Address: <b>{orderDetails?.email}</b></p></div>
                    <div class="col-12"><p>Phone Number: <b>{orderDetails?.mobileNumber}</b></p></div>
                    <div class="col-12"><p>No. of Persons: <b>{orderDetails?.noOfPersons}</b></p></div>
                    <div class="col-12"><p>Hotel Type: <b>{orderDetails?.hotelType}</b></p></div>
                    <div class="col-12"><p>Start Date: <b>{orderDetails?.startDate}</b></p></div>
                    <div class="col-12"><p>End Date: <b>{orderDetails?.endDate}</b></p></div>
                    <div class="col-12"><p>Optional Message: <b>{orderDetails?.message}</b></p></div>
                    <div class="col-12"><p>Website: <b>{orderDetails?.website}</b></p></div>
                    <div class="col-12"><p>Submit Date/Time: <b>{orderDetails?.submit_date}</b></p></div>
                </div>
                <AdminFooter />
            </div>
        </div>
    );
}

export default AdminEnquiryView;